/**
 * Copyright Mántum All Rights Reserved.
 */
import Internal from './component';
import Validator from '../validator';
import { EVENT_CLEAR, ACTION_VALUE, useGroupDispatch } from '../../group';
import { forwardRef, useRef, useImperativeHandle, useState } from 'react';

import type { DataGrid as Component, Detail } from '@mantum/kanela';
import type { PropTypes } from './component';

export default forwardRef<Detail<unknown>, PropTypes>(
    function File(props, ref) {
        // prettier-ignore
        const { 
            name, 
            optional = true 
        } = props;

        const dispatch = useGroupDispatch();

        const [error, setError] = useState(props.error);
        const [message, setMessage] = useState<string>();

        const inputRef = useRef<Component>(null);

        useImperativeHandle(
            ref,
            () => {
                return {
                    name,
                    validable: !optional,
                    clear() {
                        if (name) {
                            dispatch({
                                type: EVENT_CLEAR,
                                content: [
                                    {
                                        action: ACTION_VALUE,
                                        target: name
                                    }
                                ]
                            });
                        }
                    },
                    validate() {
                        setError(false);
                        const result = inputRef.current?.validate();
                        if (!result) {
                            setError(true);
                            setMessage(props.validation?.message);
                            return false;
                        }
                        return true;
                    },
                    value() {
                        return inputRef.current?.value();
                    }
                };
            },
            [name, optional, dispatch, props.validation?.message]
        );

        return (
            <Validator error={error} message={message} type='file'>
                <Internal
                    {...props}
                    error={error}
                    onChange={props.onChange}
                    ref={inputRef}
                />
            </Validator>
        );
    }
);
